// import React, { useState } from "react";
// import "./HelpDesk.css";
// import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy";

// // ─── Flow Step Component ──────────────────────────────────────────────────────
// const FlowStep = ({ step, title, desc, role, color, icon, isLast }) => (
//   <div className="hd-flow-item">
//     <div className="hd-flow-left">
//       <div className="hd-flow-circle" style={{ background: color }}>
//         <span className="hd-flow-icon">{icon}</span>
//       </div>
//       {!isLast && <div className="hd-flow-line" />}
//     </div>
//     <div className="hd-flow-card">
//       <div className="hd-flow-step-badge" style={{ background: color + "20", color }}>
//         Step {step}
//       </div>
//       <div className="hd-flow-card-title">{title}</div>
//       <div className="hd-flow-card-role">
//         <span className="hd-role-pill" style={{ background: color + "15", color }}>
//           👤 {role}
//         </span>
//       </div>
//       <div className="hd-flow-card-desc">{desc}</div>
//     </div>
//   </div>
// );

// // ─── Status Badge Component ───────────────────────────────────────────────────
// const StatusBadge = ({ label, color, bg }) => (
//   <span className="hd-status-badge" style={{ color, background: bg, border: `1px solid ${color}40` }}>
//     {label}
//   </span>
// );

// // ─── Tip Box Component ────────────────────────────────────────────────────────
// const TipBox = ({ type, title, children }) => {
//   const styles = {
//     tip:  { bg: "#e3f2fd", border: "#2576bc", icon: "💡" },
//     warn: { bg: "#fff8e1", border: "#f39c12", icon: "⚠️" },
//     info: { bg: "#e8f5e9", border: "#27ae60", icon: "ℹ️" },
//   };
//   const s = styles[type] || styles.info;
//   return (
//     <div className="hd-tipbox" style={{ background: s.bg, borderLeft: `4px solid ${s.border}` }}>
//       <div className="hd-tipbox-title" style={{ color: s.border }}>
//         {s.icon} {title}
//       </div>
//       <div className="hd-tipbox-body">{children}</div>
//     </div>
//   );
// };

// // ─── FAQ Accordion Component ──────────────────────────────────────────────────
// const FaqItem = ({ q, a }) => {
//   const [open, setOpen] = useState(false);
//   return (
//     <div className={`hd-faq-item ${open ? "hd-faq-open" : ""}`}>
//       <button className="hd-faq-q" onClick={() => setOpen(!open)}>
//         <span>{q}</span>
//         <span className="hd-faq-arrow">{open ? "▲" : "▼"}</span>
//       </button>
//       {open && <div className="hd-faq-a">{a}</div>}
//     </div>
//   );
// };

// // ─── MODULE DATA ─────────────────────────────────────────────────────────────
// const MODULES = [
//   { id: "imprest",    label: "Imprest",        emoji: "💼", color: "#2576bc" },
//   { id: "expense",    label: "Expense",         emoji: "🧾", color: "#e67e22" },
//   { id: "leave",      label: "Leave",           emoji: "🏖️", color: "#27ae60" },
//   { id: "outduty",    label: "Out Duty",        emoji: "🚗", color: "#8e44ad" },
//   { id: "shortleave", label: "Short Leave",     emoji: "⏰", color: "#e74c3c" },
//   { id: "advance",    label: "Advance",         emoji: "💳", color: "#16a085" },
//   { id: "salary",     label: "Salary / Payroll",emoji: "💰", color: "#2980b9" },
//   { id: "separation", label: "Separation",      emoji: "🚪", color: "#c0392b" },
//   { id: "attendance", label: "Attendance",      emoji: "📅", color: "#1a5c38" },
//   { id: "appraisal",  label: "Appraisal",       emoji: "⭐", color: "#d35400" },
// ];

// // ─── IMPREST MODULE CONTENT ───────────────────────────────────────────────────
// const ImprestContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#2576bc15,#2576bc05)" }}>
//       <div className="hd-module-hero-icon">💼</div>
//       <div>
//         <h2 className="hd-module-hero-title">Imprest Management</h2>
//         <p className="hd-module-hero-sub">
//           Imprest matlab advance petty cash jo employee ko kisi official trip ya project ke liye pehle se milta hai,
//           taaki woh apne kharche kar sake aur baad mein bills submit kare.
//         </p>
//       </div>
//     </div>

//     <TipBox type="info" title="Imprest kya hota hai?">
//       Jab aapko koi official kaam ke liye bahar jaana ho (site visit, client meeting, travel) aur aapko pehle paise chahiye —
//       toh aap <strong>Imprest</strong> apply karte ho. Company aapko advance deti hai. Trip ke baad aap bills attach karke
//       <strong> Expense</strong> submit karte ho.
//     </TipBox>

//     <h3 className="hd-section-title">📋 Imprest Apply Karne ke Steps</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📝" color="#2576bc" role="Employee"
//         title="Imprest Form Fill Karo"
//         desc="Dashboard → Imprest & Expense → 'Apply Imprest' button click karo. Amount, reason, project details (agar mandatory hai) fill karo. Date of request auto-fill hoti hai."
//       />
//       <FlowStep step={2} icon="👆" color="#8e44ad" role="HOD (Head of Department)"
//         title="HOD Approval"
//         desc="Tumhara HOD request dekh ke approve ya reject karta hai. Approve hua toh agla step. Reject hua toh status 'HOD Rejected' dikhega."
//       />
//       <FlowStep step={3} icon="🔑" color="#e67e22" role="Admin"
//         title="Admin Final Approval"
//         desc="Admin imprest amount aur purpose verify karta hai. Approve karne ke baad accounts ko fund release karne ka signal milta hai."
//       />
//       <FlowStep step={4} icon="💰" color="#27ae60" role="Accounts"
//         title="Accounts Fund Release"
//         isLast
//         desc="Accounts team payment process karti hai. Fund employee ke account ya cash mein transfer hota hai. Ab aap officially imprest amount use kar sakte ho."
//       />
//     </div>

//     <h3 className="hd-section-title">📊 Status Meanings</h3>
//     <div className="hd-status-grid">
//       <div className="hd-status-card">
//         <StatusBadge label="Pending" color="#f39c12" bg="#fff8e1" />
//         <p>Request abhi kisi ke paas approval ke liye wait kar rahi hai.</p>
//       </div>
//       <div className="hd-status-card">
//         <StatusBadge label="HOD Approved" color="#2576bc" bg="#e3f2fd" />
//         <p>HOD ne approve kar diya, Admin ke paas gaya hai.</p>
//       </div>
//       <div className="hd-status-card">
//         <StatusBadge label="Admin Approved" color="#27ae60" bg="#e8f5e9" />
//         <p>Admin ne bhi approve kar diya, Accounts payment karengi.</p>
//       </div>
//       <div className="hd-status-card">
//         <StatusBadge label="Rejected" color="#e74c3c" bg="#fdecea" />
//         <p>Kisi ne reject kiya. Reason dekho aur dobara apply karo.</p>
//       </div>
//     </div>

//     <TipBox type="tip" title="Important Settings">
//       Agar <strong>"Project Details in Imprest Mandatory"</strong> setting ON hai, toh imprest form mein project select karna zaroori hai —
//       warna form submit nahi hoga.
//     </TipBox>

//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Imprest aur Expense mein kya fark hai?"
//       a="Imprest = pehle advance lo, kaam karo. Expense = kaam ke baad bills submit karo aur reimbursement lo. Ek cycle mein usually pehle Imprest apply hota hai, phir trip ke baad Expense submit hoti hai." />
//     <FaqItem q="Kitna imprest amount apply kar sakte hain?"
//       a="Amount limit HR ya Admin decide karta hai. Koi fixed limit portal mein set nahi hai, lekin HOD aur Admin amount check karke approve ya reject karte hain." />
//     <FaqItem q="Imprest reject ho gaya toh kya karein?"
//       a="Rejection reason carefully padho (status ke paas dikhta hai). Agar misunderstanding hai toh HR se contact karo ya reason fix karke dobara apply karo." />
//     <FaqItem q="Imprest approve hone mein kitna time lagta hai?"
//       a="HOD aur Admin ki availability pe depend karta hai. Usually 1-2 working days. Agar jyada time ho raha ho toh apne HOD ya HR ko remind karo." />
//   </div>
// );

// // ─── EXPENSE MODULE CONTENT ───────────────────────────────────────────────────
// const ExpenseContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#e67e2215,#e67e2205)" }}>
//       <div className="hd-module-hero-icon">🧾</div>
//       <div>
//         <h2 className="hd-module-hero-title">Expense Management</h2>
//         <p className="hd-module-hero-sub">
//           Official kaam ke baad apne actual kharchon ke bills submit karo aur company se reimbursement ya settlement lो.
//         </p>
//       </div>
//     </div>

//     <TipBox type="info" title="Expense kab submit karte hain?">
//       Trip ya project khatam hone ke baad, aapko apne <strong>actual bills</strong> (travel, food, hotel, fuel) attach karke
//       Expense submit karni hoti hai. Agar imprest liya tha toh settlement hoti hai — zyada kharch kiya toh company degi,
//       kam kiya toh wapas karna hoga.
//     </TipBox>

//     <h3 className="hd-section-title">📋 Expense Submit Karne ke Steps</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📸" color="#e67e22" role="Employee"
//         title="Bills ke saath Expense Submit Karo"
//         desc="Imprest & Expense → New Expense → Apne actual kharch ki details fill karo. Har item ke liye category select karo (travel, food, etc.) aur bill photo/PDF attach karo." />
//       <FlowStep step={2} icon="👁️" color="#8e44ad" role="HOD"
//         title="HOD Review"
//         desc="HOD bills aur amounts verify karta hai. Agar koi item suspicious lage toh HOD partially approve ya reject kar sakta hai." />
//       <FlowStep step={3} icon="✅" color="#e67e22" role="Admin"
//         title="Admin Review"
//         desc="Admin overall expense verify karta hai. Amount aur purpose check karke approve karta hai." />
//       <FlowStep step={4} icon="🔍" color="#2576bc" role="Accounts - Stage 1"
//         title="Bill Authentication"
//         desc="Accounts team original bills ki authenticity verify karti hai. Agar bill fake ya doubtful lage toh reject ho sakta hai." />
//       <FlowStep step={5} icon="💸" color="#27ae60" role="Accounts - Stage 2"
//         isLast
//         title="Final Payment / Settlement"
//         desc="Bills authenticate hone ke baad final settlement hoti hai. Imprest amount tha toh usse adjust karke baaki payment milti hai." />
//     </div>

//     <h3 className="hd-section-title">📊 Status Meanings</h3>
//     <div className="hd-status-grid">
//       <div className="hd-status-card"><StatusBadge label="Submitted" color="#2576bc" bg="#e3f2fd" /><p>Expense submit ho gayi, HOD review karega.</p></div>
//       <div className="hd-status-card"><StatusBadge label="HOD Approved" color="#8e44ad" bg="#f3e5f5" /><p>HOD se approve, Admin ke paas.</p></div>
//       <div className="hd-status-card"><StatusBadge label="Admin Approved" color="#e67e22" bg="#fff3e0" /><p>Admin se approve, Accounts ke paas.</p></div>
//       <div className="hd-status-card"><StatusBadge label="Bill Authenticated" color="#27ae60" bg="#e8f5e9" /><p>Bills verify ho gayi, payment process hogi.</p></div>
//       <div className="hd-status-card"><StatusBadge label="Settled" color="#27ae60" bg="#e8f5e9" /><p>Payment complete! Settlement ho gayi.</p></div>
//       <div className="hd-status-card"><StatusBadge label="Partially Approved" color="#f39c12" bg="#fff8e1" /><p>Kuch items approve, kuch reject. Details dekho.</p></div>
//     </div>

//     <TipBox type="warn" title="Expense Submission Deadline">
//       Portal mein <strong>Expense Submission Limit</strong> setting hoti hai. Agar ON hai, toh ek fixed number of days ke andar
//       expense submit karni hogi. Deadline miss karne par submission block ho sakti hai. HR se deadline confirm karo.
//     </TipBox>

//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Bill nahi hai toh expense submit kar sakte hain?"
//       a="Bill mandatory hai accounts stage mein authentication ke liye. Bina bill ke expense reject ho sakti hai. Har purchase ka receipt/photo zaroori rakho." />
//     <FaqItem q="Agar imprest se zyada kharch hua toh?"
//       a="Diff amount company degi final settlement mein. Example: 5000 imprest liya, 6500 kharch hua → company 1500 degi." />
//     <FaqItem q="Agar imprest se kam kharch hua toh?"
//       a="Bacha hua amount wapas karna hoga. Example: 5000 imprest liya, 3000 kharch hua → 2000 wapas karo." />
//     <FaqItem q="Expense partially approved kya matlab?"
//       a="HOD ya Admin ne kuch items valid mane kuch nahi. Approved items ka hi payment milega. Details mein dekho kaunse items reject hue." />
//   </div>
// );

// // ─── LEAVE MODULE CONTENT ─────────────────────────────────────────────────────
// const LeaveContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#27ae6015,#27ae6005)" }}>
//       <div className="hd-module-hero-icon">🏖️</div>
//       <div>
//         <h2 className="hd-module-hero-title">Leave Management</h2>
//         <p className="hd-module-hero-sub">Chutti apply karo, track karo, aur apna leave balance dekho — sab ek jagah.</p>
//       </div>
//     </div>

//     <h3 className="hd-section-title">📋 Leave Apply Karne ke Steps</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📝" color="#27ae60" role="Employee" title="Leave Apply Karo"
//         desc="Dashboard → Attendance & Leaves → Apply Leave. Leave type select karo (Casual/Sick/Earned), dates choose karo, reason likho aur submit karo." />
//       <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head (RH)" title="RH Approval"
//         desc="Tumhara Reporting Head (manager) request dekh ke approve ya reject karta hai. Approved hone par agla step." />
//       <FlowStep step={3} icon="✅" color="#27ae60" role="Admin / HR" isLast title="Admin Final Approval"
//         desc="Admin ya HR final approval deta hai. Dono approve hone ke baad attendance automatically 'Leave' mark ho jaati hai." />
//     </div>

//     <h3 className="hd-section-title">📅 Leave Types</h3>
//     <div className="hd-info-grid">
//       {[
//         { t: "Casual Leave (CL)", d: "Personal kaam ke liye. Monthly credit hoti hai settings ke hisaab se.", c: "#2576bc" },
//         { t: "Sick Leave (SL)", d: "Bimari ya medical reason ke liye.", c: "#e74c3c" },
//         { t: "Earned / Previous Leave (PL)", d: "Service ke baad earn hoti hai, accumulate hoti hai.", c: "#27ae60" },
//         { t: "Short Leave", d: "Kuch ghante ke liye. Late aana ya jaldi jaana.", c: "#f39c12" },
//         { t: "Comp Off", d: "Weekend ya holiday pe kaam karne ke badle milti hai.", c: "#8e44ad" },
//       ].map(l => (
//         <div key={l.t} className="hd-info-card" style={{ borderLeft: `4px solid ${l.c}` }}>
//           <div className="hd-info-card-title" style={{ color: l.c }}>{l.t}</div>
//           <div className="hd-info-card-desc">{l.d}</div>
//         </div>
//       ))}
//     </div>

//     <TipBox type="warn" title="Sandwich Rule">
//       Agar aapne <strong>Friday aur Monday</strong> leave li — Saturday aur Sunday beech mein hain.
//       Agar Sandwich Rule ON hai toh Saturday-Sunday bhi leave count honge = 4 din ki leave kategi!
//       HR se confirm karo ki apki company mein sandwich rule applicable hai ya nahi.
//     </TipBox>

//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Leave apply karne ki time limit kya hai?"
//       a="Portal settings mein 'Leave Apply Past Limit' aur 'Future Limit' set hota hai. Jaise 30 din peeche ya 60 din aage tak apply kar sakte ho. Limit ke baad apply nahi hoga." />
//     <FaqItem q="RH ne approve kiya lekin Admin ne reject kiya — kya matlab?"
//       a="Dono approvals zaroori hain. Agar Admin reject kare, toh leave count nahi hogi. HR se reason poochho." />
//     <FaqItem q="Leave balance kahan dekhen?"
//       a="Employee Dashboard → Leave Balance section mein har leave type ka available balance dikhta hai." />
//     <FaqItem q="Leave encashment kya hai?"
//       a="Kuch leave types cash mein convert ho sakti hain ek specific date pe. HR ya portal settings se confirm karo." />
//   </div>
// );

// // ─── OUT DUTY MODULE CONTENT ──────────────────────────────────────────────────
// const OutDutyContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#8e44ad15,#8e44ad05)" }}>
//       <div className="hd-module-hero-icon">🚗</div>
//       <div>
//         <h2 className="hd-module-hero-title">Out Duty (OD)</h2>
//         <p className="hd-module-hero-sub">Office se bahar official kaam ke liye gaye? Out Duty apply karo taaki attendance absent mark na ho.</p>
//       </div>
//     </div>

//     <TipBox type="info" title="Out Duty kab apply karein?">
//       Jab aap office ke bahar kisi official kaam se jaate ho (client visit, site visit, government office, etc.)
//       toh Out Duty apply karo. Approved OD pe attendance <strong>"Out Duty"</strong> mark hoti hai na ki "Absent".
//     </TipBox>

//     <h3 className="hd-section-title">📋 Out Duty Apply ke Steps</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📝" color="#8e44ad" role="Employee" title="OD Apply Karo"
//         desc="Dashboard → Attendance & Leaves → Out Duty tab → Apply karo. Start date, end date, reason aur duration fill karo." />
//       <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head (RH)" title="RH Approval"
//         desc="RH request approve ya reject karta hai. RH approved = next step. RH rejected = request closed." />
//       <FlowStep step={3} icon="✅" color="#8e44ad" role="Admin / HR" isLast title="Admin Final Approval"
//         desc="Admin approve karne ke baad attendance Out Duty status pe update hoti hai. RH rejected hai aur Admin status pending hai toh bypass feature use ho sakta hai (agar enabled)." />
//     </div>

//     <TipBox type="tip" title="OD Bypass Feature">
//       Agar RH ne approval nahi diya aur <strong>od_approval_limit</strong> days guzar gaye,
//       toh Admin directly approve kar sakta hai (agar OD Bypass setting ON hai).
//       <br/>Example: OD apply ki 1 Jan ko, limit 5 din — 6 Jan ke baad Admin bypass kar sakta hai.
//     </TipBox>

//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="OD aur Leave mein kya fark hai?"
//       a="OD = Office ke bahar official kaam. Leave = Personal/medical wajah se absent. OD approved ho toh attendance 'Out Duty' hoti hai. Leave approved ho toh 'Leave' hoti hai." />
//     <FaqItem q="OD ke baad Comp Off milega?"
//       a="Agar portal setting mein 'Comp Off for WeeklyOff OD' ON hai aur aapne Saturday/Sunday ko OD ki toh Comp Off milega." />
//     <FaqItem q="OD apply karne ki deadline kya hai?"
//       a="Settings mein 'OD Apply Past Limit' define hota hai. Uss limit ke andar hi past OD apply ho sakti hai." />
//   </div>
// );

// // ─── SHORT LEAVE CONTENT ──────────────────────────────────────────────────────
// const ShortLeaveContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#e74c3c15,#e74c3c05)" }}>
//       <div className="hd-module-hero-icon">⏰</div>
//       <div>
//         <h2 className="hd-module-hero-title">Short Leave & Comp Off</h2>
//         <p className="hd-module-hero-sub">Kuch ghante late aaye ya jaldi gaye? Short Leave apply karo. Weekend pe kaam kiya? Comp Off lo.</p>
//       </div>
//     </div>

//     <h3 className="hd-section-title">🔵 Short Leave kya hai?</h3>
//     <TipBox type="info" title="Short Leave">
//       Aap office aaye lekin poore ghante nahi kiye (late aaya ya jaldi gaya). System detect karta hai ki aap us din
//       short leave ke liye eligible ho. Aap manually apply kar sakte ho ya auto-apply setting ON hai toh system khud apply kar deta hai.
//     </TipBox>

//     <h3 className="hd-section-title">🟢 Comp Off kya hai?</h3>
//     <TipBox type="info" title="Comp Off">
//       Aapne Saturday, Sunday ya Holiday pe kaam kiya — uske badle aapko ek din ki extra leave milti hai.
//       Is extra leave ko Compensatory Off (Comp Off) kehte hain.
//     </TipBox>

//     <h3 className="hd-section-title">📋 Short Leave / Comp Off Apply ke Steps</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="🔍" color="#e74c3c" role="System / Employee" title="Eligible Date Select Karo"
//         desc="Compensatory section mein jaao. System automatically wo dates dikhata hai jis din aap Short Leave ya Comp Off ke liye eligible ho (April 2026 se aage ki dates)." />
//       <FlowStep step={2} icon="📝" color="#e74c3c" role="Employee" title="Date aur Reason Select Karo"
//         desc="Date select karo — system automatically 'Short Leave' ya 'Comp Off' set karta hai (Comp Off ko priority milti hai). Reason aur Instructed By fill karo." />
//       <FlowStep step={3} icon="✅" color="#27ae60" role="HR" isLast title="Submit aur HR Process"
//         desc="Submit karo. HR/Admin review karta hai." />
//     </div>

//     <TipBox type="warn" title="Priority Rule">
//       Agar ek hi din pe dono eligible ho — <strong>Comp Off ko priority milti hai</strong> Short Leave ke upar.
//       Duration automatically set hota hai, manually change nahi karna hota.
//     </TipBox>

//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Date select nahi ho rahi, kya karna hai?"
//       a="Agar date dropdown empty hai iska matlab ya toh auto-apply setting ON hai (system khud apply kar deta hai) ya us date pe pehle se request exist karti hai." />
//     <FaqItem q="Comp Off expire hota hai?"
//       a="Portal settings pe depend karta hai. HR se confirm karo ki comp off ki validity kitni hai." />
//   </div>
// );

// // ─── ADVANCE CONTENT ─────────────────────────────────────────────────────────
// const AdvanceContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#16a08515,#16a08505)" }}>
//       <div className="hd-module-hero-icon">💳</div>
//       <div>
//         <h2 className="hd-module-hero-title">Advance Management</h2>
//         <p className="hd-module-hero-sub">Aane wali salary se pehle advance loan lena ho toh yahan apply karo.</p>
//       </div>
//     </div>
//     <TipBox type="info" title="Advance kya hai?">
//       Advance = Salary aane se pehle emergency mein company se loan lena. Yeh amount baad mein salary se deduct hota hai.
//     </TipBox>
//     <h3 className="hd-section-title">📋 Advance Apply ke Steps</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📝" color="#16a085" role="Employee" title="Advance Form Fill Karo"
//         desc="Amount aur reason fill karo. Date auto-fill hoti hai." />
//       <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head" title="RH Approval" desc="RH approve ya reject karta hai." />
//       <FlowStep step={3} icon="👆" color="#8e44ad" role="HOD" title="HOD Approval" desc="HOD verify karta hai." />
//       <FlowStep step={4} icon="🔑" color="#e67e22" role="Admin" title="Admin Approval" desc="Admin final check karta hai." />
//       <FlowStep step={5} icon="✅" color="#27ae60" role="HR" title="HR Approval + Amount Confirm"
//         desc="HR approved amount confirm karta hai — yeh actual disbursement amount hoga." />
//       <FlowStep step={6} icon="💰" color="#16a085" role="Accounts" isLast title="Accounts Final Payment"
//         desc="Accounts payment process karti hai. Amount account mein transfer hoti hai." />
//     </div>
//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Advance kitni bar apply kar sakte hain?"
//       a="Previous advance fully repay hone ke baad hi nayi advance apply ho sakti hai. HR se confirm karo." />
//     <FaqItem q="Advance salary se kaise deduct hoga?"
//       a="Accounts aur HR monthly deduction schedule set karte hain. Salary slip mein deduction clearly dikhega." />
//   </div>
// );

// // ─── SALARY CONTENT ───────────────────────────────────────────────────────────
// const SalaryContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#2980b915,#2980b905)" }}>
//       <div className="hd-module-hero-icon">💰</div>
//       <div>
//         <h2 className="hd-module-hero-title">Salary / Payroll</h2>
//         <p className="hd-module-hero-sub">Apna salary slip dekho, TDS calculation samjho, aur increment history check karo.</p>
//       </div>
//     </div>
//     <h3 className="hd-section-title">📋 Salary Slip Kahan Milega?</h3>
//     <div className="hd-steps-list">
//       <div className="hd-step-item"><span className="hd-step-num">1</span><span>Dashboard → Payroll Management → Employee Salary Records</span></div>
//       <div className="hd-step-item"><span className="hd-step-num">2</span><span>Month select karo → apna slip dekho ya download karo</span></div>
//       <div className="hd-step-item"><span className="hd-step-num">3</span><span>Slip sirf tab dikhegi jab <strong>"Show Salary Slip"</strong> setting ON ho (HR se confirm karo)</span></div>
//     </div>
//     <h3 className="hd-section-title">🧾 Salary Slip mein kya hota hai?</h3>
//     <div className="hd-info-grid">
//       {[
//         { t: "Basic Salary", d: "Base pay jo fix hoti hai", c: "#2576bc" },
//         { t: "HRA", d: "House Rent Allowance", c: "#27ae60" },
//         { t: "Deductions", d: "PF, TDS, Advance recovery", c: "#e74c3c" },
//         { t: "Net Pay", d: "Haath mein milne wali salary (Gross - Deductions)", c: "#8e44ad" },
//         { t: "Gross Pay", d: "Deduction se pehle ki total salary", c: "#e67e22" },
//         { t: "TDS", d: "Income Tax monthly deduction", c: "#2980b9" },
//       ].map(l => (
//         <div key={l.t} className="hd-info-card" style={{ borderLeft: `4px solid ${l.c}` }}>
//           <div className="hd-info-card-title" style={{ color: l.c }}>{l.t}</div>
//           <div className="hd-info-card-desc">{l.d}</div>
//         </div>
//       ))}
//     </div>
//     <TipBox type="tip" title="Payroll Cycle">
//       Company ka payroll cycle custom ho sakta hai. Jaise payroll start 26 ko aur end 25 ko — iska matlab April ki
//       salary = 26 March to 25 April ka period. HR se confirm karo apne company ka cycle.
//     </TipBox>
//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Salary slip nahi dikh raha?"
//       a="'Show Salary Slip' portal setting ON honi chahiye. HR ya Admin se request karo ki setting enable karein." />
//     <FaqItem q="TDS zyada kata — kya karna hai?"
//       a="Investment Declaration section mein jaao aur apni investments declare karo (80C, 80D etc.). TDS automatically adjust hogi." />
//     <FaqItem q="Salary mein galti hai — kisko batayein?"
//       a="Immediate apne HR ya Accounts team ko email/message karo with salary slip details. Next month correction possible hai." />
//   </div>
// );

// // ─── SEPARATION CONTENT ───────────────────────────────────────────────────────
// const SeparationContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#c0392b15,#c0392b05)" }}>
//       <div className="hd-module-hero-icon">🚪</div>
//       <div>
//         <h2 className="hd-module-hero-title">Separation / Offboarding</h2>
//         <p className="hd-module-hero-sub">Company se resign karna ho ya exit process complete karni ho toh yahan se shuru karo.</p>
//       </div>
//     </div>
//     <h3 className="hd-section-title">📋 Separation Process Flow</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📝" color="#c0392b" role="Employee" title="Resignation Apply Karo"
//         desc="Separation form fill karo — reason, last working date, notice period details." />
//       <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head" title="RH Approval"
//         desc="Direct manager approval deta hai." />
//       <FlowStep step={3} icon="👆" color="#8e44ad" role="HOD" title="HOD Approval"
//         desc="Department head clearance deta hai." />
//       <FlowStep step={4} icon="🏢" color="#e67e22" role="Custom Departments" title="Department-wise NOC"
//         desc="IT (laptop return), Admin (ID card), Finance (dues clear) — company ke format ke hisaab se custom departments clearance dete hain." />
//       <FlowStep step={5} icon="✅" color="#27ae60" role="HR" title="HR Final Clearance"
//         desc="HR experience letter, F&F calculation process karta hai." />
//       <FlowStep step={6} icon="🔑" color="#c0392b" role="Admin" title="Admin Approval"
//         desc="Admin final sign-off deta hai." />
//       <FlowStep step={7} icon="💰" color="#16a085" role="Accounts" title="F&F Settlement"
//         desc="Final dues, pending salary, notice period recovery calculate karke payment process hoti hai." />
//       <FlowStep step={8} icon="🎯" color="#2c3e50" role="HR" isLast title="Final Separation"
//         desc="Exit formalities complete. Employee status inactive ho jaata hai." />
//     </div>
//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Notice period kitna hoga?"
//       a="Notice period aapki employment contract mein clearly likha hota hai. Separation form mein last working date select karte waqt notice period calculate ho jaata hai." />
//     <FaqItem q="F&F (Full & Final) mein kya kya include hota hai?"
//       a="Pending salary + Leave encashment - TDS - Advance recovery - Notice period recovery = Net F&F amount. HR aur Accounts team calculate karke settlement karte hain." />
//   </div>
// );

// // ─── ATTENDANCE CONTENT ───────────────────────────────────────────────────────
// const AttendanceContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#1a5c3815,#1a5c3805)" }}>
//       <div className="hd-module-hero-icon">📅</div>
//       <div>
//         <h2 className="hd-module-hero-title">Attendance</h2>
//         <p className="hd-module-hero-sub">Apni daily attendance, punch-in/out timing, aur attendance status dekho aur samjho.</p>
//       </div>
//     </div>
//     <h3 className="hd-section-title">🔵 Attendance Status Guide</h3>
//     <div className="hd-status-grid">
//       {[
//         { label:"Present", color:"#06ad06", bg:"#d4f4dd", desc:"Aap office aye aur poore ghante kiye." },
//         { label:"Absent", color:"#e74c3c", bg:"#fdecea", desc:"Punch-in nahi hui (in_time = 00:00:00)." },
//         { label:"Leave", color:"#f7ba1e", bg:"#fff3cd", desc:"Approved leave tha uss din." },
//         { label:"Out Duty", color:"#3dcdcd", bg:"#e0f7fa", desc:"Approved OD tha — bahar official kaam." },
//         { label:"Short Leave", color:"#06ad06", bg:"#d4f4dd", desc:"Partial din — late aaye ya jaldi gaye." },
//         { label:"Weekly Off", color:"#2576bc", bg:"#e3f2fd", desc:"Saturday/Sunday ya weekly holiday." },
//         { label:"Holiday", color:"#2576bc", bg:"#e3f2fd", desc:"Company holiday." },
//         { label:"Half Day", color:"#f7ba1e", bg:"#fff3cd", desc:"Aadha din present aadha absent." },
//         { label:"Late", color:"#f7ba1e", bg:"#fff3cd", desc:"Office time ke baad aaye." },
//         { label:"Miss Punch", color:"#e74c3c", bg:"#fdecea", desc:"Punch-in ya out miss hua." },
//       ].map(s => (
//         <div key={s.label} className="hd-status-card">
//           <StatusBadge label={s.label} color={s.color} bg={s.bg} />
//           <p>{s.desc}</p>
//         </div>
//       ))}
//     </div>
//     <TipBox type="warn" title="Attendance Regularization">
//       Miss punch ya wrong attendance ka issue ho toh HR se <strong>Attendance Regularization</strong> request karo.
//       HR correct in/out time update kar sakta hai with valid reason.
//     </TipBox>
//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Attendance absent dikh raha hai lekin main office aya tha?"
//       a="Punch-in miss ho gayi hogi. HR ko Attendance Regularization request do with office entry proof (email/message/CCTV)." />
//     <FaqItem q="Purani attendance kaise dekhen?"
//       a="Dashboard → Employee Attendance → Date range select karo (default last 60 days). Status filter se specific status dekh sakte ho." />
//   </div>
// );

// // ─── APPRAISAL CONTENT ────────────────────────────────────────────────────────
// const AppraisalContent = () => (
//   <div className="hd-module-content">
//     <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#d3540015,#d3540005)" }}>
//       <div className="hd-module-hero-icon">⭐</div>
//       <div>
//         <h2 className="hd-module-hero-title">Appraisal</h2>
//         <p className="hd-module-hero-sub">Performance review aur rating system — apni self-assessment karo aur manager se review lo.</p>
//       </div>
//     </div>
//     <h3 className="hd-section-title">📋 Appraisal Flow</h3>
//     <div className="hd-flow-container">
//       <FlowStep step={1} icon="📝" color="#d35400" role="Employee" title="Self Assessment"
//         desc="Appraisal form mein apni performance ka self-rating do har parameter pe (Communication, Technical Skills, Punctuality, etc.)." />
//       <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head" title="RH Rating"
//         desc="Reporting Head tumhari performance ka apna rating deta hai same parameters pe." />
//       <FlowStep step={3} icon="🏢" color="#8e44ad" role="HOD" title="HOD Review"
//         desc="HOD overall department performance ke context mein review karta hai." />
//       <FlowStep step={4} icon="✅" color="#d35400" role="Admin / HR" isLast title="Final Review"
//         desc="Admin final appraisal records lock karta hai. Increment/promotion decisions is data pe based hote hain." />
//     </div>
//     <h3 className="hd-section-title">❓ Aksar Pooche Jaane Wale Sawal</h3>
//     <FaqItem q="Appraisal form kab aata hai?"
//       a="HR appraisal cycle setup karta hai ek specific time period ke liye. HR notification ya dashboard pe announcement se pata chalega." />
//     <FaqItem q="Self rating aur manager rating different ho — kya hoga?"
//       a="Dono ratings record hoti hain. Final discussion mein manager explain karta hai. Yeh normal process hai." />
//   </div>
// );

// // ─── CONTENT MAP ─────────────────────────────────────────────────────────────
// const CONTENT_MAP = {
//   imprest:    <ImprestContent />,
//   expense:    <ExpenseContent />,
//   leave:      <LeaveContent />,
//   outduty:    <OutDutyContent />,
//   shortleave: <ShortLeaveContent />,
//   advance:    <AdvanceContent />,
//   salary:     <SalaryContent />,
//   separation: <SeparationContent />,
//   attendance: <AttendanceContent />,
//   appraisal:  <AppraisalContent />,
// };

// // ─── MAIN HELP DESK COMPONENT ─────────────────────────────────────────────────
// const HelpDeskDisplay = () => {
//   const [activeModule, setActiveModule] = useState(null);
//   const [search, setSearch] = useState("");

//   const filtered = MODULES.filter(m =>
//     m.label.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <>
//       <Dashboardnavbarcopy name="Help Desk" url="Help Desk" />
//       <div className="hd-wrapper">

//         {/* ── Header ── */}
//         <div className="hd-header">
//           <div className="hd-header-left">
//             <div className="hd-header-icon">🎯</div>
//             <div>
//               <h1 className="hd-header-title">Help Desk</h1>
//               <p className="hd-header-sub">
//                 Koi bhi module samajhna ho — yahan se step-by-step guide lo. Technical knowledge bilkul zaroori nahi!
//               </p>
//             </div>
//           </div>
//           <div className="hd-search-wrap">
//             <span className="hd-search-icon">🔍</span>
//             <input
//               className="hd-search"
//               placeholder="Module dhundho... (Leave, Imprest, Salary...)"
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="hd-body">
//           {/* ── Left: Module Grid ── */}
//           <div className="hd-sidebar">
//             <div className="hd-sidebar-title">📚 Modules</div>
//             <div className="hd-module-grid">
//               {filtered.map(m => (
//                 <button
//                   key={m.id}
//                   className={`hd-module-btn ${activeModule === m.id ? "hd-module-btn-active" : ""}`}
//                   style={activeModule === m.id ? { borderColor: m.color, background: m.color + "12" } : {}}
//                   onClick={() => setActiveModule(m.id)}
//                 >
//                   <span className="hd-module-emoji">{m.emoji}</span>
//                   <span className="hd-module-label" style={activeModule === m.id ? { color: m.color } : {}}>
//                     {m.label}
//                   </span>
//                   {activeModule === m.id && <span className="hd-module-arrow" style={{ color: m.color }}>›</span>}
//                 </button>
//               ))}
//             </div>

//             {/* Quick Tips */}
//             <div className="hd-quick-tips">
//               <div className="hd-qt-title">⚡ Quick Tips</div>
//               <ul className="hd-qt-list">
//                 <li>Koi bhi request apply karne se pehle uska module guide padho</li>
//                 <li>Status "Pending" dikh raha hai toh wait karo ya manager ko remind karo</li>
//                 <li>Reject hua toh reason padho aur HR se contact karo</li>
//                 <li>Bills ka photo hamesha rakho expense ke liye</li>
//               </ul>
//             </div>
//           </div>

//           {/* ── Right: Content ── */}
//           <div className="hd-content">
//             {activeModule ? (
//               <>
//                 <button className="hd-back-btn" onClick={() => setActiveModule(null)}>
//                   ← Wapas Jaao
//                 </button>
//                 {CONTENT_MAP[activeModule]}
//               </>
//             ) : (
//               <div className="hd-welcome">
//                 <div className="hd-welcome-illus">🎓</div>
//                 <h2 className="hd-welcome-title">HRMS Help Desk mein aapka swagat hai!</h2>
//                 <p className="hd-welcome-sub">
//                   Baayi taraf se koi bhi module select karo aur uska poora flow samjho —
//                   step-by-step explanation, flow chart, aur common questions ke saath.
//                 </p>
//                 <div className="hd-popular-grid">
//                   <div className="hd-popular-title">🔥 Aksar Dekhe Jane Wale Modules</div>
//                   <div className="hd-popular-cards">
//                     {["imprest","expense","leave","outduty"].map(id => {
//                       const m = MODULES.find(x => x.id === id);
//                       return (
//                         <button key={id} className="hd-popular-card" onClick={() => setActiveModule(id)}
//                           style={{ borderTop: `3px solid ${m.color}` }}>
//                           <span className="hd-popular-emoji">{m.emoji}</span>
//                           <span className="hd-popular-label">{m.label}</span>
//                           <span className="hd-popular-cta" style={{ color: m.color }}>Guide padho →</span>
//                         </button>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default HelpDeskDisplay;



import React, { useState } from "react";
import "./HelpDesk.css";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy";

// ─── Flow Step Component ──────────────────────────────────────────────────────
const FlowStep = ({ step, title, desc, role, color, icon, isLast }) => (
  <div className="hd-flow-item">
    <div className="hd-flow-left">
      <div className="hd-flow-circle" style={{ background: color }}>
        <span className="hd-flow-icon">{icon}</span>
      </div>
      {!isLast && <div className="hd-flow-line" />}
    </div>
    <div className="hd-flow-card">
      <div className="hd-flow-step-badge" style={{ background: color + "20", color }}>
        Step {step}
      </div>
      <div className="hd-flow-card-title">{title}</div>
      <div className="hd-flow-card-role">
        <span className="hd-role-pill" style={{ background: color + "15", color }}>
          👤 {role}
        </span>
      </div>
      <div className="hd-flow-card-desc">{desc}</div>
    </div>
  </div>
);

// ─── Status Badge Component ───────────────────────────────────────────────────
const StatusBadge = ({ label, color, bg }) => (
  <span className="hd-status-badge" style={{ color, background: bg, border: `1px solid ${color}40` }}>
    {label}
  </span>
);

// ─── Tip Box Component ────────────────────────────────────────────────────────
const TipBox = ({ type, title, children }) => {
  const styles = {
    tip: { bg: "#e3f2fd", border: "#2576bc", icon: "💡" },
    warn: { bg: "#fff8e1", border: "#f39c12", icon: "⚠️" },
    info: { bg: "#e8f5e9", border: "#27ae60", icon: "ℹ️" },
  };
  const s = styles[type] || styles.info;
  return (
    <div className="hd-tipbox" style={{ background: s.bg, borderLeft: `4px solid ${s.border}` }}>
      <div className="hd-tipbox-title" style={{ color: s.border }}>
        {s.icon} {title}
      </div>
      <div className="hd-tipbox-body">{children}</div>
    </div>
  );
};

// ─── FAQ Accordion Component ──────────────────────────────────────────────────
const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`hd-faq-item ${open ? "hd-faq-open" : ""}`}>
      <button className="hd-faq-q" onClick={() => setOpen(!open)}>
        <span>{q}</span>
        <span className="hd-faq-arrow">{open ? "▲" : "▼"}</span>
      </button>
      {open && <div className="hd-faq-a">{a}</div>}
    </div>
  );
};

// ─── MODULE DATA ─────────────────────────────────────────────────────────────
const MODULES = [
  { id: "imprest", label: "Imprest", emoji: "💼", color: "#2576bc" },
  { id: "expense", label: "Expense", emoji: "🧾", color: "#e67e22" },
  { id: "leave", label: "Leave", emoji: "🏖️", color: "#27ae60" },
  { id: "outduty", label: "Out Duty", emoji: "🚗", color: "#8e44ad" },
  { id: "shortleave", label: "Short Leave", emoji: "⏰", color: "#e74c3c" },
  { id: "advance", label: "Advance", emoji: "💳", color: "#16a085" },
  { id: "salary", label: "Salary / Payroll", emoji: "💰", color: "#2980b9" },
  { id: "separation", label: "Separation", emoji: "🚪", color: "#c0392b" },
  { id: "attendance", label: "Attendance", emoji: "📅", color: "#1a5c38" },
  { id: "appraisal", label: "Appraisal", emoji: "⭐", color: "#d35400" },
];

// ─── IMPREST MODULE CONTENT ───────────────────────────────────────────────────
const ImprestContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#2576bc15,#2576bc05)" }}>
      <div className="hd-module-hero-icon">💼</div>
      <div>
        <h2 className="hd-module-hero-title">Imprest Management</h2>
        <p className="hd-module-hero-sub">
          An imprest is an advance petty cash amount given to an employee before an official trip or project,
          so they can cover expenses and submit bills afterward.
        </p>
      </div>
    </div>

    <TipBox type="info" title="What is an Imprest?">
      When you need to travel for official work (site visit, client meeting, travel) and need money in advance —
      you apply for an <strong>Imprest</strong>. The company gives you an advance. After the trip, you attach your bills
      and submit an <strong>Expense</strong> claim.
    </TipBox>

    <h3 className="hd-section-title">📋 Steps to Apply for Imprest</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📝" color="#2576bc" role="Employee"
        title="Fill the Imprest Form"
        desc="Go to Dashboard → Imprest & Expense → click 'Apply Imprest'. Fill in the amount, reason, and project details (if mandatory). The request date is filled in automatically."
      />
      <FlowStep step={2} icon="👆" color="#8e44ad" role="HOD (Head of Department)"
        title="HOD Approval"
        desc="Your HOD reviews the request and approves or rejects it. If approved, it moves to the next step. If rejected, the status will show 'HOD Rejected'."
      />
      <FlowStep step={3} icon="🔑" color="#e67e22" role="Admin"
        title="Admin Final Approval"
        desc="Admin verifies the imprest amount and purpose. Once approved, Accounts is signaled to release the funds."
      />
      <FlowStep step={4} icon="💰" color="#27ae60" role="Accounts"
        title="Accounts Fund Release"
        isLast
        desc="The Accounts team processes the payment. Funds are transferred to the employee's account or given as cash. You can now officially use the imprest amount."
      />
    </div>

    <h3 className="hd-section-title">📊 Status Meanings</h3>
    <div className="hd-status-grid">
      <div className="hd-status-card">
        <StatusBadge label="Pending" color="#f39c12" bg="#fff8e1" />
        <p>The request is waiting for someone's approval.</p>
      </div>
      <div className="hd-status-card">
        <StatusBadge label="HOD Approved" color="#2576bc" bg="#e3f2fd" />
        <p>HOD has approved it; it has moved to Admin.</p>
      </div>
      <div className="hd-status-card">
        <StatusBadge label="Admin Approved" color="#27ae60" bg="#e8f5e9" />
        <p>Admin has also approved it; Accounts will process payment.</p>
      </div>
      <div className="hd-status-card">
        <StatusBadge label="Rejected" color="#e74c3c" bg="#fdecea" />
        <p>Someone rejected the request. Check the reason and re-apply if needed.</p>
      </div>
    </div>

    <TipBox type="tip" title="Important Settings">
      If the <strong>"Project Details in Imprest Mandatory"</strong> setting is ON, you must select a project in the
      form — otherwise the form won't submit.
    </TipBox>

    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="What's the difference between Imprest and Expense?"
      a="Imprest = take an advance first, then do the work. Expense = submit bills after the work is done and get reimbursed. Usually, you apply for Imprest first, then submit an Expense claim after the trip." />
    <FaqItem q="How much imprest amount can I apply for?"
      a="The amount limit is decided by HR or Admin. There's no fixed limit set in the portal, but HOD and Admin check the amount before approving or rejecting." />
    <FaqItem q="What if my imprest request gets rejected?"
      a="Carefully read the rejection reason (shown next to the status). If it's a misunderstanding, contact HR, or fix the issue and re-apply." />
    <FaqItem q="How long does imprest approval take?"
      a="It depends on your HOD's and Admin's availability. Usually 1-2 working days. If it's taking longer, follow up with your HOD or HR." />
  </div>
);

// ─── EXPENSE MODULE CONTENT ───────────────────────────────────────────────────
const ExpenseContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#e67e2215,#e67e2205)" }}>
      <div className="hd-module-hero-icon">🧾</div>
      <div>
        <h2 className="hd-module-hero-title">Expense Management</h2>
        <p className="hd-module-hero-sub">
          Submit bills for your actual expenses after official work and get reimbursement or settlement from the company.
        </p>
      </div>
    </div>

    <TipBox type="info" title="When should you submit an Expense?">
      After a trip or project is finished, you need to submit your <strong>actual bills</strong> (travel, food, hotel, fuel)
      as an Expense claim. If you had taken an imprest, it gets settled — if you spent more than the imprest, the
      company pays the difference; if you spent less, you return the remainder.
    </TipBox>

    <h3 className="hd-section-title">📋 Steps to Submit an Expense</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📸" color="#e67e22" role="Employee"
        title="Submit Expense with Bills"
        desc="Go to Imprest & Expense → New Expense → fill in your actual expense details. Select a category for each item (travel, food, etc.) and attach a photo or PDF of the bill." />
      <FlowStep step={2} icon="👁️" color="#8e44ad" role="HOD"
        title="HOD Review"
        desc="HOD verifies the bills and amounts. If any item looks suspicious, HOD can partially approve or reject it." />
      <FlowStep step={3} icon="✅" color="#e67e22" role="Admin"
        title="Admin Review"
        desc="Admin verifies the overall expense claim. Approves after checking the amount and purpose." />
      <FlowStep step={4} icon="🔍" color="#2576bc" role="Accounts - Stage 1"
        title="Bill Authentication"
        desc="The Accounts team verifies the authenticity of the original bills. If a bill looks fake or doubtful, it may be rejected." />
      <FlowStep step={5} icon="💸" color="#27ae60" role="Accounts - Stage 2"
        isLast
        title="Final Payment / Settlement"
        desc="Once bills are authenticated, final settlement happens. If an imprest was taken, it's adjusted and the remaining amount is paid." />
    </div>

    <h3 className="hd-section-title">📊 Status Meanings</h3>
    <div className="hd-status-grid">
      <div className="hd-status-card"><StatusBadge label="Submitted" color="#2576bc" bg="#e3f2fd" /><p>Expense has been submitted; HOD will review it.</p></div>
      <div className="hd-status-card"><StatusBadge label="HOD Approved" color="#8e44ad" bg="#f3e5f5" /><p>Approved by HOD; now with Admin.</p></div>
      <div className="hd-status-card"><StatusBadge label="Admin Approved" color="#e67e22" bg="#fff3e0" /><p>Approved by Admin; now with Accounts.</p></div>
      <div className="hd-status-card"><StatusBadge label="Bill Authenticated" color="#27ae60" bg="#e8f5e9" /><p>Bills verified; payment will be processed.</p></div>
      <div className="hd-status-card"><StatusBadge label="Settled" color="#27ae60" bg="#e8f5e9" /><p>Payment complete! Settlement done.</p></div>
      <div className="hd-status-card"><StatusBadge label="Partially Approved" color="#f39c12" bg="#fff8e1" /><p>Some items approved, some rejected. Check the details.</p></div>
    </div>

    <TipBox type="warn" title="Expense Submission Deadline">
      The portal has an <strong>Expense Submission Limit</strong> setting. If it's ON, you must submit expenses within
      a fixed number of days. Missing the deadline may block submission. Confirm the deadline with HR.
    </TipBox>

    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="Can I submit an expense without a bill?"
      a="A bill is mandatory for authentication at the Accounts stage. Without a bill, the expense may get rejected. Always keep a receipt/photo of every purchase." />
    <FaqItem q="What if I spent more than the imprest amount?"
      a="The company pays the difference during final settlement. Example: took ₹5000 imprest, spent ₹6500 → the company pays you ₹1500." />
    <FaqItem q="What if I spent less than the imprest amount?"
      a="You need to return the remaining amount. Example: took ₹5000 imprest, spent ₹3000 → return ₹2000." />
    <FaqItem q="What does 'Partially Approved' mean for an expense?"
      a="HOD or Admin considered some items valid and some not. You'll only be paid for the approved items. Check the details to see which items were rejected." />
  </div>
);

// ─── LEAVE MODULE CONTENT ─────────────────────────────────────────────────────
const LeaveContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#27ae6015,#27ae6005)" }}>
      <div className="hd-module-hero-icon">🏖️</div>
      <div>
        <h2 className="hd-module-hero-title">Leave Management</h2>
        <p className="hd-module-hero-sub">Apply for leave, track it, and check your leave balance — all in one place.</p>
      </div>
    </div>

    <h3 className="hd-section-title">📋 Steps to Apply for Leave</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📝" color="#27ae60" role="Employee" title="Apply for Leave"
        desc="Go to Dashboard → Attendance & Leaves → Apply Leave. Select the leave type (Casual/Sick/Earned), choose dates, write a reason, and submit." />
      <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head (RH)" title="RH Approval"
        desc="Your Reporting Head (manager) reviews the request and approves or rejects it. Once approved, it moves to the next step." />
      <FlowStep step={3} icon="✅" color="#27ae60" role="Admin / HR" isLast title="Admin Final Approval"
        desc="Admin or HR gives final approval. Once both approvals are done, attendance is automatically marked as 'Leave'." />
    </div>

    <h3 className="hd-section-title">📅 Leave Types</h3>
    <div className="hd-info-grid">
      {[
        { t: "Casual Leave (CL)", d: "For personal work. Credited monthly based on settings.", c: "#2576bc" },
        { t: "Sick Leave (SL)", d: "For illness or medical reasons.", c: "#e74c3c" },
        { t: "Earned / Previous Leave (PL)", d: "Earned based on service and accumulates over time.", c: "#27ae60" },
        { t: "Short Leave", d: "For a few hours — arriving late or leaving early.", c: "#f39c12" },
        { t: "Comp Off", d: "Given in exchange for working on a weekend or holiday.", c: "#8e44ad" },
      ].map(l => (
        <div key={l.t} className="hd-info-card" style={{ borderLeft: `4px solid ${l.c}` }}>
          <div className="hd-info-card-title" style={{ color: l.c }}>{l.t}</div>
          <div className="hd-info-card-desc">{l.d}</div>
        </div>
      ))}
    </div>

    <TipBox type="warn" title="Sandwich Rule">
      If you take leave on <strong>Friday and Monday</strong> — with Saturday and Sunday in between —
      and the Sandwich Rule is ON, Saturday and Sunday will also count as leave = 4 days of leave deducted!
      Confirm with HR whether the sandwich rule applies at your company.
    </TipBox>

    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="Is there a time limit to apply for leave?"
      a="Portal settings define a 'Leave Apply Past Limit' and 'Future Limit' — for example, up to 30 days in the past or 60 days in the future. You can't apply outside this limit." />
    <FaqItem q="RH approved it but Admin rejected it — what does that mean?"
      a="Both approvals are required. If Admin rejects it, the leave won't be counted. Ask HR for the reason." />
    <FaqItem q="Where can I check my leave balance?"
      a="Go to Employee Dashboard → Leave Balance section to see the available balance for each leave type." />
    <FaqItem q="What is leave encashment?"
      a="Some leave types can be converted into cash on a specific date. Confirm this with HR or check the portal settings." />
  </div>
);

// ─── OUT DUTY MODULE CONTENT ──────────────────────────────────────────────────
const OutDutyContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#8e44ad15,#8e44ad05)" }}>
      <div className="hd-module-hero-icon">🚗</div>
      <div>
        <h2 className="hd-module-hero-title">Out Duty (OD)</h2>
        <p className="hd-module-hero-sub">Went out of the office for official work? Apply for Out Duty so your attendance isn't marked absent.</p>
      </div>
    </div>

    <TipBox type="info" title="When should you apply for Out Duty?">
      When you go outside the office for official work (client visit, site visit, government office, etc.),
      apply for Out Duty. Once approved, your attendance is marked as <strong>"Out Duty"</strong> instead of "Absent".
    </TipBox>

    <h3 className="hd-section-title">📋 Steps to Apply for Out Duty</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📝" color="#8e44ad" role="Employee" title="Apply for OD"
        desc="Go to Dashboard → Attendance & Leaves → Out Duty tab → Apply. Fill in start date, end date, reason, and duration." />
      <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head (RH)" title="RH Approval"
        desc="RH approves or rejects the request. If approved, it moves to the next step. If rejected, the request is closed." />
      <FlowStep step={3} icon="✅" color="#8e44ad" role="Admin / HR" isLast title="Admin Final Approval"
        desc="Once Admin approves, attendance is updated to Out Duty status. If RH rejected and Admin's status is still pending, the bypass feature may apply (if enabled)." />
    </div>

    <TipBox type="tip" title="OD Bypass Feature">
      If RH hasn't approved and the <strong>od_approval_limit</strong> (in days) has passed,
      Admin can directly approve it (if the OD Bypass setting is ON).
      <br />Example: OD applied on Jan 1, limit is 5 days — Admin can bypass after Jan 6.
    </TipBox>

    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="What's the difference between OD and Leave?"
      a="OD = official work outside the office. Leave = absence for personal/medical reasons. If OD is approved, attendance shows 'Out Duty'. If Leave is approved, it shows 'Leave'." />
    <FaqItem q="Will I get a Comp Off after an OD?"
      a="If the portal setting 'Comp Off for WeeklyOff OD' is ON and you did OD on a Saturday/Sunday, you'll get a Comp Off." />
    <FaqItem q="Is there a deadline to apply for OD?"
      a="The 'OD Apply Past Limit' setting defines this. You can only apply for past OD within that limit." />
  </div>
);

// ─── SHORT LEAVE CONTENT ──────────────────────────────────────────────────────
const ShortLeaveContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#e74c3c15,#e74c3c05)" }}>
      <div className="hd-module-hero-icon">⏰</div>
      <div>
        <h2 className="hd-module-hero-title">Short Leave & Comp Off</h2>
        <p className="hd-module-hero-sub">Arrived late or left early by a few hours? Apply for Short Leave. Worked on a weekend? Take a Comp Off.</p>
      </div>
    </div>

    <h3 className="hd-section-title">🔵 What is Short Leave?</h3>
    <TipBox type="info" title="Short Leave">
      You came to office but didn't complete full hours (arrived late or left early). The system detects that you're
      eligible for short leave that day. You can apply manually, or if the auto-apply setting is ON, the system applies it automatically.
    </TipBox>

    <h3 className="hd-section-title">🟢 What is Comp Off?</h3>
    <TipBox type="info" title="Comp Off">
      You worked on a Saturday, Sunday, or Holiday — in exchange, you get an extra day off.
      This extra day off is called Compensatory Off (Comp Off).
    </TipBox>

    <h3 className="hd-section-title">📋 Steps to Apply for Short Leave / Comp Off</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="🔍" color="#e74c3c" role="System / Employee" title="Select an Eligible Date"
        desc="Go to the Compensatory section. The system automatically shows dates you're eligible for Short Leave or Comp Off (from April 2026 onward)." />
      <FlowStep step={2} icon="📝" color="#e74c3c" role="Employee" title="Select Date and Reason"
        desc="Select a date — the system automatically sets it as 'Short Leave' or 'Comp Off' (Comp Off takes priority). Fill in the reason and 'Instructed By'." />
      <FlowStep step={3} icon="✅" color="#27ae60" role="HR" isLast title="Submit and HR Processing"
        desc="Submit the request. HR/Admin reviews it." />
    </div>

    <TipBox type="warn" title="Priority Rule">
      If you're eligible for both on the same day — <strong>Comp Off takes priority</strong> over Short Leave.
      Duration is set automatically and shouldn't be changed manually.
    </TipBox>

    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="I can't select a date, what should I do?"
      a="If the date dropdown is empty, it means either the auto-apply setting is ON (the system applies it automatically) or a request for that date already exists." />
    <FaqItem q="Does Comp Off expire?"
      a="This depends on portal settings. Confirm the validity period of Comp Off with HR." />
  </div>
);

// ─── ADVANCE CONTENT ─────────────────────────────────────────────────────────
const AdvanceContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#16a08515,#16a08505)" }}>
      <div className="hd-module-hero-icon">💳</div>
      <div>
        <h2 className="hd-module-hero-title">Advance Management</h2>
        <p className="hd-module-hero-sub">Need a loan against your upcoming salary? Apply here.</p>
      </div>
    </div>
    <TipBox type="info" title="What is an Advance?">
      An Advance is an emergency loan taken from the company before your salary is credited. This amount is later
      deducted from your salary.
    </TipBox>
    <h3 className="hd-section-title">📋 Steps to Apply for Advance</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📝" color="#16a085" role="Employee" title="Fill the Advance Form"
        desc="Fill in the amount and reason. The date is filled in automatically." />
      <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head" title="RH Approval" desc="RH approves or rejects the request." />
      <FlowStep step={3} icon="👆" color="#8e44ad" role="HOD" title="HOD Approval" desc="HOD verifies the request." />
      <FlowStep step={4} icon="🔑" color="#e67e22" role="Admin" title="Admin Approval" desc="Admin does the final check." />
      <FlowStep step={5} icon="✅" color="#27ae60" role="HR" title="HR Approval + Amount Confirmation"
        desc="HR confirms the approved amount — this becomes the actual disbursement amount." />
      <FlowStep step={6} icon="💰" color="#16a085" role="Accounts" isLast title="Accounts Final Payment"
        desc="Accounts processes the payment. The amount is transferred to your account." />
    </div>
    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="How many times can I apply for an advance?"
      a="You can only apply for a new advance once the previous one has been fully repaid. Confirm this with HR." />
    <FaqItem q="How is the advance deducted from salary?"
      a="Accounts and HR set up a monthly deduction schedule. The deduction will be clearly shown on your salary slip." />
  </div>
);

// ─── SALARY CONTENT ───────────────────────────────────────────────────────────
const SalaryContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#2980b915,#2980b905)" }}>
      <div className="hd-module-hero-icon">💰</div>
      <div>
        <h2 className="hd-module-hero-title">Salary / Payroll</h2>
        <p className="hd-module-hero-sub">View your salary slip, understand TDS calculations, and check your increment history.</p>
      </div>
    </div>
    <h3 className="hd-section-title">📋 Where Do I Find My Salary Slip?</h3>
    <div className="hd-steps-list">
      <div className="hd-step-item"><span className="hd-step-num">1</span><span>Go to Dashboard → Payroll Management → Employee Salary Records</span></div>
      <div className="hd-step-item"><span className="hd-step-num">2</span><span>Select a month → view or download your slip</span></div>
      <div className="hd-step-item"><span className="hd-step-num">3</span><span>The slip is only visible when the <strong>"Show Salary Slip"</strong> setting is ON (confirm with HR)</span></div>
    </div>
    <h3 className="hd-section-title">🧾 What's on the Salary Slip?</h3>
    <div className="hd-info-grid">
      {[
        { t: "Basic Salary", d: "Fixed base pay", c: "#2576bc" },
        { t: "HRA", d: "House Rent Allowance", c: "#27ae60" },
        { t: "Deductions", d: "PF, TDS, Advance recovery", c: "#e74c3c" },
        { t: "Net Pay", d: "Take-home salary (Gross - Deductions)", c: "#8e44ad" },
        { t: "Gross Pay", d: "Total salary before deductions", c: "#e67e22" },
        { t: "TDS", d: "Monthly income tax deduction", c: "#2980b9" },
      ].map(l => (
        <div key={l.t} className="hd-info-card" style={{ borderLeft: `4px solid ${l.c}` }}>
          <div className="hd-info-card-title" style={{ color: l.c }}>{l.t}</div>
          <div className="hd-info-card-desc">{l.d}</div>
        </div>
      ))}
    </div>
    <TipBox type="tip" title="Payroll Cycle">
      Your company's payroll cycle may be custom. For example, if payroll starts on the 25th and ends on the 24th —
      this means June's salary covers the period 25 May to 24 June. Confirm your company's cycle with HR.
    </TipBox>
    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="My salary slip isn't showing?"
      a="The 'Show Salary Slip' portal setting needs to be ON. Ask HR or Admin to enable this setting." />
    <FaqItem q="Too much TDS was deducted — what should I do?"
      a="Go to the Investment Declaration section and declare your investments (80C, 80D, etc.). TDS will be adjusted automatically." />
    <FaqItem q="There's a mistake in my salary — who do I tell?"
      a="Immediately email or message your HR or Accounts team with your salary slip details. Correction is usually possible in the next month." />
  </div>
);

// ─── SEPARATION CONTENT ───────────────────────────────────────────────────────
const SeparationContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#c0392b15,#c0392b05)" }}>
      <div className="hd-module-hero-icon">🚪</div>
      <div>
        <h2 className="hd-module-hero-title">Separation / Offboarding</h2>
        <p className="hd-module-hero-sub">Resigning from the company or completing your exit process? Start here.</p>
      </div>
    </div>
    <h3 className="hd-section-title">📋 Separation Process Flow</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📝" color="#c0392b" role="Employee" title="Apply for Resignation"
        desc="Fill in the separation form — reason, last working date, and notice period details." />
      <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head" title="RH Approval"
        desc="Your direct manager approves it." />
      <FlowStep step={3} icon="👆" color="#8e44ad" role="HOD" title="HOD Approval"
        desc="The department head gives clearance." />
      <FlowStep step={4} icon="🏢" color="#e67e22" role="Custom Departments" title="Department-wise NOC"
        desc="IT (laptop return), Admin (ID card), Finance (dues clearance) — custom departments give clearance based on your company's format." />
      <FlowStep step={5} icon="✅" color="#27ae60" role="HR" title="HR Final Clearance"
        desc="HR processes the experience letter and F&F calculation." />
      <FlowStep step={6} icon="🔑" color="#c0392b" role="Admin" title="Admin Approval"
        desc="Admin gives the final sign-off." />
      <FlowStep step={7} icon="💰" color="#16a085" role="Accounts" title="F&F Settlement"
        desc="Final dues, pending salary, and notice period recovery are calculated, and payment is processed." />
      <FlowStep step={8} icon="🎯" color="#2c3e50" role="HR" isLast title="Final Separation"
        desc="Exit formalities are complete. The employee's status becomes inactive." />
    </div>
    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="What will my notice period be?"
      a="Your notice period is clearly stated in your employment contract. When you select the last working date in the separation form, the notice period is calculated automatically." />
    <FaqItem q="What's included in F&F (Full & Final) settlement?"
      a="Pending salary + Leave encashment - TDS - Advance recovery - Notice period recovery = Net F&F amount. HR and the Accounts team calculate and process the settlement." />
  </div>
);

// ─── ATTENDANCE CONTENT ───────────────────────────────────────────────────────
const AttendanceContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#1a5c3815,#1a5c3805)" }}>
      <div className="hd-module-hero-icon">📅</div>
      <div>
        <h2 className="hd-module-hero-title">Attendance</h2>
        <p className="hd-module-hero-sub">View and understand your daily attendance, punch-in/out timing, and attendance status.</p>
      </div>
    </div>
    <h3 className="hd-section-title">🔵 Attendance Status Guide</h3>
    <div className="hd-status-grid">
      {[
        { label: "Present", color: "#06ad06", bg: "#d4f4dd", desc: "You came to office and completed full hours." },
        { label: "Absent", color: "#e74c3c", bg: "#fdecea", desc: "No punch-in was recorded (in_time = 00:00:00)." },
        { label: "Leave", color: "#f7ba1e", bg: "#fff3cd", desc: "An approved leave was active that day." },
        { label: "Out Duty", color: "#3dcdcd", bg: "#e0f7fa", desc: "An approved OD was active — official work outside the office." },
        { label: "Short Leave", color: "#06ad06", bg: "#d4f4dd", desc: "Partial day — arrived late or left early." },
        { label: "Weekly Off", color: "#2576bc", bg: "#e3f2fd", desc: "Saturday/Sunday or a weekly holiday." },
        { label: "Holiday", color: "#2576bc", bg: "#e3f2fd", desc: "Company holiday." },
        { label: "Half Day", color: "#f7ba1e", bg: "#fff3cd", desc: "Half day present, half day absent." },
        { label: "Late", color: "#f7ba1e", bg: "#fff3cd", desc: "Arrived after office start time." },
        { label: "Miss Punch", color: "#e74c3c", bg: "#fdecea", desc: "Punch-in or punch-out was missed." },
      ].map(s => (
        <div key={s.label} className="hd-status-card">
          <StatusBadge label={s.label} color={s.color} bg={s.bg} />
          <p>{s.desc}</p>
        </div>
      ))}
    </div>
    <TipBox type="warn" title="Attendance Regularization">
      If there's a miss punch or incorrect attendance issue, request <strong>Attendance Regularization</strong> from HR.
      HR can update the correct in/out time with a valid reason.
    </TipBox>
    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="My attendance shows absent, but I was in the office?"
      a="Your punch-in was probably missed. Request Attendance Regularization from HR along with proof of your office entry (email/message/CCTV)." />
    <FaqItem q="How do I view past attendance?"
      a="Go to Dashboard → Employee Attendance → select a date range (defaults to last 60 days). Use the status filter to view a specific status." />
  </div>
);

// ─── APPRAISAL CONTENT ────────────────────────────────────────────────────────
const AppraisalContent = () => (
  <div className="hd-module-content">
    <div className="hd-module-hero" style={{ background: "linear-gradient(135deg,#d3540015,#d3540005)" }}>
      <div className="hd-module-hero-icon">⭐</div>
      <div>
        <h2 className="hd-module-hero-title">Appraisal</h2>
        <p className="hd-module-hero-sub">Performance review and rating system — do your self-assessment and get reviewed by your manager.</p>
      </div>
    </div>
    <h3 className="hd-section-title">📋 Appraisal Flow</h3>
    <div className="hd-flow-container">
      <FlowStep step={1} icon="📝" color="#d35400" role="Employee" title="Self Assessment"
        desc="Rate your own performance on each parameter in the appraisal form (Communication, Technical Skills, Punctuality, etc.)." />
      <FlowStep step={2} icon="👆" color="#2576bc" role="Reporting Head" title="RH Rating"
        desc="Your Reporting Head gives their own rating on the same parameters." />
      <FlowStep step={3} icon="🏢" color="#8e44ad" role="HOD" title="HOD Review"
        desc="HOD reviews performance in the context of overall department performance." />
      <FlowStep step={4} icon="✅" color="#d35400" role="Admin / HR" isLast title="Final Review"
        desc="Admin locks the final appraisal record. Increment and promotion decisions are based on this data." />
    </div>
    <h3 className="hd-section-title">❓ Frequently Asked Questions</h3>
    <FaqItem q="When does the appraisal form open?"
      a="HR sets up the appraisal cycle for a specific time period. You'll be notified via a dashboard announcement or notification." />
    <FaqItem q="What if my self-rating differs from my manager's rating?"
      a="Both ratings are recorded. The final discussion is where the manager explains the difference. This is a normal part of the process." />
  </div>
);

// ─── CONTENT MAP ─────────────────────────────────────────────────────────────
const CONTENT_MAP = {
  imprest: <ImprestContent />,
  expense: <ExpenseContent />,
  leave: <LeaveContent />,
  outduty: <OutDutyContent />,
  shortleave: <ShortLeaveContent />,
  advance: <AdvanceContent />,
  salary: <SalaryContent />,
  separation: <SeparationContent />,
  attendance: <AttendanceContent />,
  appraisal: <AppraisalContent />,
};

// ─── MAIN HELP DESK COMPONENT ─────────────────────────────────────────────────
const HelpDeskDisplay = () => {
  const [activeModule, setActiveModule] = useState(null);
  const [search, setSearch] = useState("");

  const filtered = MODULES.filter(m =>
    m.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Dashboardnavbarcopy name="Help Desk" url="Help Desk" />
      <div className="hd-wrapper">

        {/* ── Header ── */}
        <div className="hd-header">
          <div className="hd-header-left">
            <div className="hd-header-icon">🎯</div>
            <div>
              <h1 className="hd-header-title">Help Desk</h1>
              <p className="hd-header-sub">
                Need to understand any module? Get a step-by-step guide here!
              </p>
            </div>
          </div>
          <div className="hd-search-wrap">
            <span className="hd-search-icon">🔍</span>
            <input
              className="hd-search"
              placeholder="Search modules... (Leave, Imprest, Salary...)"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="hd-body">
          {/* ── Left: Module Grid ── */}
          <div className="hd-sidebar">
            <div className="hd-sidebar-title">📚 Modules</div>
            <div className="hd-module-grid">
              {filtered.map(m => (
                <button
                  key={m.id}
                  className={`hd-module-btn ${activeModule === m.id ? "hd-module-btn-active" : ""}`}
                  style={activeModule === m.id ? { borderColor: m.color, background: m.color + "12" } : {}}
                  onClick={() => setActiveModule(m.id)}
                >
                  <span className="hd-module-emoji">{m.emoji}</span>
                  <span className="hd-module-label" style={activeModule === m.id ? { color: m.color } : {}}>
                    {m.label}
                  </span>
                  {activeModule === m.id && <span className="hd-module-arrow" style={{ color: m.color }}>›</span>}
                </button>
              ))}
            </div>

            {/* Quick Tips */}
            <div className="hd-quick-tips">
              <div className="hd-qt-title">⚡ Quick Tips</div>
              <ul className="hd-qt-list">
                <li>Read the relevant module guide before applying for any request</li>
                <li>If the status shows "Pending", wait or send a reminder to your manager</li>
                <li>If rejected, read the reason and contact HR</li>
                <li>Always keep a photo of bills for expense claims</li>
              </ul>
            </div>
          </div>

          {/* ── Right: Content ── */}
          <div className="hd-content">
            {activeModule ? (
              <>
                <button className="hd-back-btn" onClick={() => setActiveModule(null)}>
                  ← Go Back
                </button>
                {CONTENT_MAP[activeModule]}
              </>
            ) : (
              <div className="hd-welcome">
                <div className="hd-welcome-illus">🎓</div>
                <h2 className="hd-welcome-title">Welcome to the HRMS Help Desk!</h2>
                <p className="hd-welcome-sub">
                  Select any module from the left and understand its complete flow —
                  with step-by-step explanations, a flow chart, and common questions.
                </p>
                <div className="hd-popular-grid">
                  <div className="hd-popular-title">🔥 Most Viewed Modules</div>
                  <div className="hd-popular-cards">
                    {["imprest", "expense", "leave", "outduty", "shortleave", "advance", "salary", "separation", "attendance", "appraisal"].map(id => {
                      const m = MODULES.find(x => x.id === id);
                      return (
                        <button key={id} className="hd-popular-card" onClick={() => setActiveModule(id)}
                          style={{ borderTop: `3px solid ${m.color}` }}>
                          <span className="hd-popular-emoji">{m.emoji}</span>
                          <span className="hd-popular-label">{m.label}</span>
                          <span className="hd-popular-cta" style={{ color: m.color }}>Read guide →</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpDeskDisplay;